import { defineComponent as _defineComponent } from 'vue'
import { useEmit } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ReservationUpdateSMSOptIn',
  props: {
  modelValue: {
    type: Boolean as () => boolean,
    required: true,
  },
},
  emits: ['update:modelValue'],
  setup(__props, { emit }) {



/**
 * Explicitly declares the events this component can emit.
 * In Vue 2, `defineEmits` is not enforced but is recommended for documentation,
 * type safety, and tooling support. However, in Vue 3, `defineEmits` is enforced,
 * and emitting undeclared events will throw an error.
 */


const onChange = (value: boolean) => {
  emit('update:modelValue', value)
}

return { __sfc: true,emit, onChange }
}

})